
import { Options, Vue } from 'vue-class-component';
import { mapState } from 'vuex';
// Components
import Answer from '@/components/quiz/Answer.vue';
// Types
import { Alternative, Quiz } from '@/types/quiz.d';

@Options({
  components: {
    Answer,
  },
  computed: mapState(['answearsQuiz', 'currentQuiz']),
})
export default class ReviewAnswers extends Vue {
  answearsQuiz!: Alternative[];

  currentQuiz!: Quiz;

  goBack(): void {
    this.$router.back();
  }
}
